const fmtPercent = (n) =>
    `${new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 2 }).format(
        Number(n) || 0
    )}٪`;

const SCENARIO_COLORS = {
    'محتاط': '#10b981',
    'متعادل': '#3b82f6',
    'سخاوتمند': '#f59e0b',
};

export default function ScenarioSelector({
                                             suggestions,
                                             selected,
                                             onSelect,
                                             showManual,
                                             onToggleManual,
                                             manualValue,
                                             onManualChange,
                                             minMargin,
                                         }) {
    if (!suggestions || suggestions.length === 0) return null;

    return (
        <div className="scenario-selector">
            <div className="scenario-selector-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                <span className="scenario-label" style={{ fontWeight: 'bold' }}>سقف پورسانت از مبلغ سبد:</span>
                <button
                    type="button"
                    className={`scenario-manual-toggle ${showManual ? 'active' : ''}`}
                    onClick={onToggleManual}
                    style={{ background: '#f1f5f9', border: '1px solid #cbd5e1', padding: '4px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '0.85rem' }}
                >
                    {showManual ? 'بازگشت به سناریوها' : 'تنظیم دستی'}
                </button>
            </div>

            {!showManual && (
                // === [CHANGED] عرض کامل با Grid و کاهش فاصله ===
                <div className="scenario-cards" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.75rem' }}>
                    {suggestions.map((s) => {
                        const isSelected = selected === s.percent;
                        const color = SCENARIO_COLORS[s.name] || '#6b7280';

                        return (
                            <button
                                key={s.name}
                                type="button"
                                className={`scenario-card ${isSelected ? 'selected' : ''}`}
                                onClick={() => onSelect(s.percent)}
                                style={{
                                    borderColor: isSelected ? color : '#e5e7eb',
                                    borderWidth: '2px',
                                    borderStyle: 'solid',
                                    borderRadius: '8px',
                                    // === [CHANGED] کاهش پدینگ عمودی برای کم شدن ارتفاع ===
                                    padding: '0.5rem 0.75rem',
                                    background: isSelected ? '#f8fafc' : '#fff',
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    // === [CHANGED] کاهش فاصله بین اجزا ===
                                    gap: '0.2rem',
                                    transition: 'all 0.2s',
                                }}
                            >
                                <div className="scenario-card-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem', width: '100%' }}>
                                    <span
                                        className="scenario-dot"
                                        style={{ background: color, width: '8px', height: '8px', borderRadius: '50%' }}
                                    />
                                    <strong style={{ fontSize: '1rem' }}>{s.name}</strong>
                                    {isSelected && (
                                        <span className="scenario-check" style={{ color: color, fontWeight: 'bold' }}>✓</span>
                                    )}
                                </div>
                                <p className="scenario-description" style={{ fontSize: '0.7rem', color: '#64748b', margin: 0, textAlign: 'center', lineHeight: '1.2' }}>{s.description}</p>
                                <div className="scenario-values" style={{ display: 'flex', justifyContent: 'space-around', width: '100%', marginTop: '0.2rem', borderTop: '1px dashed #e2e8f0', paddingTop: '0.4rem' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.1rem' }}>
                                        <span style={{ fontSize: '0.7rem', color: '#64748b' }}>سقف پورسانت</span>
                                        <strong style={{ color: '#1e293b', fontSize: '0.85rem' }}>{fmtPercent(s.percent)}</strong>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.1rem' }}>
                                        <span style={{ fontSize: '0.7rem', color: '#64748b' }}>سود فروشنده</span>
                                        <strong className={s.remaining_margin_percent >= minMargin ? 'safe' : 'danger'} style={{ color: s.remaining_margin_percent >= minMargin ? '#059669' : '#dc2626', fontSize: '0.85rem' }}>
                                            {fmtPercent(s.remaining_margin_percent)}
                                        </strong>
                                    </div>
                                </div>
                            </button>
                        );
                    })}
                </div>
            )}

            {showManual && (
                <div className="scenario-manual" style={{ textAlign: 'center', padding: '1rem', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                    <label style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                        <span>سقف پورسانت از سبد (٪)</span>
                        <input
                            type="number"
                            min="0"
                            max="100"
                            step="0.1"
                            value={manualValue}
                            onChange={(e) => onManualChange(e.target.value)}
                            style={{ width: '150px', textAlign: 'center', padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '1rem' }}
                        />
                    </label>
                    <p className="scenario-manual-hint" style={{ marginTop: '0.75rem', fontSize: '0.8rem', color: '#64748b' }}>
                        💡 برای حداکثر امنیت، پیشنهاد می‌کنیم از سناریوها استفاده کنید.
                    </p>
                </div>
            )}
        </div>
    );
}